import { pushRoute } from '../../../../../lib/router.js';
import pluralize from 'pluralize';
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import moment from 'moment';
import { getOrgTermsContent } from '../../../../../content/utils.js';
import { ProjectRoundedIcon } from '../../../../icons/ProjectRoundedIcon.jsx';
import { ProjectLink } from '../../../../links/index.jsx';
import ImpactCard from './ImpactViewCard.jsx';
import { CloseIcon } from '../../../../icons/CloseIcon.jsx';

function Index({ impacts, date, onHide, project, show }) {
  const handleClickEdit = (projectId, changeImpactId) => {
    pushRoute('projects/change-impacts/show', { projectId, changeImpactId });
  };

  const [projects, setProjects] = useState([]);

  const numberOfProjects = projects.length;
  const numberOfImpacts = impacts.length;

  useEffect(() => {
    const uniqueProjects = {};
    impacts.forEach((impact) => {
      if (!uniqueProjects[impact.projectId]) {
        uniqueProjects[impact.projectId] = impact.projectName;
      }
    });

    const projectsArray = Object.keys(uniqueProjects).map((projectId) => ({
      projectId: parseInt(projectId, 10),
      projectName: uniqueProjects[projectId],
    }));
    setProjects(projectsArray);
  }, [impacts]);

  return (
    <Modal
      onHide={() => {
        onHide();
      }}
      show={show}
    >
      {!project ? (
        <div style={{ padding: '32px 24px', position: 'relative' }}>
          <div
            onClick={onHide}
            className="cursor-pointer"
            style={{ position: 'absolute', top: '36px', right: '24px' }}
          >
            <CloseIcon />
          </div>
          <div className="text-left m-b-36">
            <div className="flex m-b-14">
              <h4 className="strong m-r-8">Date:</h4>
              <div style={{ fontSize: '16px' }}>
                {date ? moment(date).format('MM/DD/YYYY') : null}
              </div>
            </div>
            <div>
              {impacts.length > 0 ? (
                <React.Fragment>
                  <strong
                    className="bordered text-muted"
                    style={{ height: '28px', fontSize: '14px' }}
                  >
                    {pluralize(getOrgTermsContent('project'), numberOfProjects)}
                    :&nbsp;
                    <span className="text-primary count">
                      {numberOfProjects}
                    </span>
                  </strong>
                  <strong
                    className="m-l-8 bordered text-muted"
                    style={{ height: '28px', fontSize: '14px' }}
                  >
                    Change {pluralize('Impact', numberOfImpacts)}:&nbsp;
                    <span className="text-primary count">
                      {impacts ? impacts.length : null}
                    </span>
                  </strong>
                </React.Fragment>
              ) : null}
            </div>
          </div>
          <div style={{ maxHeight: 'calc(100vh - 208px)', overflow: 'auto' }}>
            {projects.map((project, index) => (
              <div
                className={
                  index < projects.length - 1
                    ? 'component-border-bottom m-b-32'
                    : ''
                }
              >
                <div className="flex m-b-14 ">
                  <h4 className="text-primary flex flex-align-center">
                    <ProjectRoundedIcon />
                    <ProjectLink projectId={project.projectId}>
                      <a>
                        <span className="m-l-8 text-primary cursor-pointer">
                          {project.projectName}
                        </span>
                      </a>
                    </ProjectLink>
                  </h4>
                  <strong
                    className="m-l-8 bordered text-muted"
                    style={{ height: '28px', fontSize: '14px' }}
                  >
                    Total:&nbsp;
                    <span className="text-primary count">
                      {impacts
                        ? impacts.filter(
                            (impact) => impact.projectId === project.projectId
                          ).length
                        : null}
                    </span>
                  </strong>
                </div>
                <div className="m-l-32 m-b-32">
                  {impacts.map((impact) =>
                    impact.projectId === project.projectId ? (
                      <ImpactCard
                        impact={impact}
                        handleClickEdit={handleClickEdit}
                        archived={project && project.archived}
                      />
                    ) : null
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div style={{ padding: '32px 24px', position: 'relative' }}>
          <div
            onClick={onHide}
            className="cursor-pointer"
            style={{ position: 'absolute', top: '36px', right: '24px' }}
          >
            <CloseIcon />
          </div>
          <div className="text-left flex">
            <h4 className="strong m-r-8">Date:</h4>
            <div style={{ fontSize: '16px' }}>
              {date ? moment(date).format('MM/DD/YYYY') : null}
            </div>
            {impacts.length > 0 ? (
              <strong
                className="m-l-8 bordered text-muted"
                style={{ height: '28px', fontSize: '14px' }}
              >
                Total:&nbsp;
                <span className="text-primary count">
                  {impacts ? impacts.length : null}
                </span>
              </strong>
            ) : null}
          </div>
          <div style={{ maxHeight: 'calc(100vh - 208px)', overflow: 'auto' }}>
            {impacts.map((impact) => (
              <ImpactCard
                impact={impact}
                handleClickEdit={handleClickEdit}
                archived={project && project.archived}
              />
            ))}
          </div>
        </div>
      )}
    </Modal>
  );
}

export default Index;
